import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import OrderColumn from "../../Global/OrderColumn";
import { FaSort } from "react-icons/fa";
import { ImageCard } from "../../Global/ImageCard";
import useCategory from "./useCategory";
import AddCategory from "./AddCategory";
import EmptyData from "../../Global/EmptyData";

const Category = () => {
  const {
    isLoading,
    isFetching,
    imageData,
    categoryList,
    showEditModal,
    categoryState,
    showImageModal,
    paginationOptions,
    updateCategoryTableFields,
    handleEditColumnsClick,
    handleDeleteModal,
    handleCreateClick,
    handleEditAction,
    handleClearClick,
    handlePagination,
    closeImageModal,
    handlePageSize,
    handleSearch,
    handleDelete,
    handleSort,
    refetch,
    getRow,
  } = useCategory();
  return (
    <div>
      <HeadingGroup
        title={"Category"}
        className={`pro-mb-4`}
        buttonTitle={categoryList?.data?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={categoryState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: categoryState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {categoryList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={categoryList?.data?.result || []}
            uniqueID={"_id"}
            fields={categoryList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={categoryState.clearSelection}
            loading={isFetching}
            perpage={categoryState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={categoryList?.data?.delete_permission}
            editable={categoryList?.data?.edit_permission}
            showCheckBox={
              categoryList?.data?.delete_permission ||
              categoryList?.data?.edit_permission
            }
          />
        )}

        {categoryList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={categoryState?.currentPage}
            totalPageCount={Math.ceil(
              categoryList?.data?.total_count / categoryState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === categoryState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={categoryState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete Category ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={categoryList?.data?.fields || []}
              moduleId={categoryList?.data?.module_id}
              updateData={updateCategoryTableFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={categoryState?.showCreateModal}
          handleClose={handleCreateClick}
          title={categoryState?.isEdit ? "Update Category" : "Add Category"}
          backdrop={"static"}
        >
          <AddCategory
            refetch={refetch}
            handleCreateClick={handleCreateClick}
            isStickyFooter
            categoryState={categoryState}
          />
        </OffCanvasLayout>
        <ModalLayout
          show={showImageModal}
          refetch={refetch}
          handleClose={closeImageModal}
          backdrop="static"
        >
          <ImageCard data={imageData} handleClose={closeImageModal} />
        </ModalLayout>
      </div>
    </div>
  );
};

export default Category;
